<template>
    <div>
        <b-form @submit.prevent="savePictogram()" data-vv-scope="formPictograms">
            <b-row>
                <b-col md="12">
                    <b-form-group>
                        <label>Nombre <span class="text-danger">*</span></label>
                        <b-form-input v-model="pictogram.name" type="text" class="form-control" name="name"
                            v-validate="'required'" data-vv-as=" " />
                        <span class="text-danger small" v-text="errors.first('formPictograms.name')" />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group>
                        <label>Imagen <span v-if="!pictogram.imageBase64" class="text-danger">*</span></label>
                        <b-form-file v-model="pictogram.image" @change="getImage"
                            accept="image/jpeg, image/png, image/jpg" name="image" placeholder="Seleccione Imagen"
                            browse-text="Buscar" type="file" v-validate="validationRuleImage" data-vv-as=" " />
                        <span class="text-danger small" v-text="errors.first('formPictograms.image')" />
                    </b-form-group>
                </b-col>

                <b-col v-if="newImageRender|| pictogram.imageBase64" md="6" class="position-relative d-flex justify-content-center align-items-center">
                    <b-form-group>
                        <h6>Imagen</h6>
                        <img :src="newImageRender || pictogram.imageBase64" alt="pictograma" width="100" class="img-pictogram" />
                    </b-form-group>
                </b-col>

                <b-col md="12" v-if="'sga_pictogram_language' in pictogram && typeof pictogram.sga_pictogram_language === 'object'">
                    <b-list-group class="mt-0">
                        <b-list-group-item v-for="language in pictogram.sga_pictogram_language" :key="language.id" v-show="language.sga_language.code !== 'ES'">
                            <div class="d-flex align-items-center">
                                <b-badge variant="primary">{{ language.sga_language.code }}</b-badge>
                                <p class="ml-3 m-0">{{language.value}}</p>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>

                <b-col md="12" class="mt-3 d-flex justify-content-end align-items-center">
                    <b-form-group>
                        <b-button variant="danger" @click="cancelPictogram">
                            <i class="fa fa-reply"></i>
                            <span class="ml-1" v-text="'Cancelar'"></span>
                        </b-button>
                        <b-button type="submit" variant="primary" class="mx-1">
                            <i class="fa fa-save"></i>
                            <span class="ml-1" v-text="'Guardar'"></span>
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>

    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
    name: 'formPictograms',
    data() {
        return {
            newImageRender: null
        }
    },

    watch: {
        "pictogram.image": {
            handler: function (newFile) {
                if (newFile) {
                    const reader = new FileReader();
                    reader.readAsDataURL(newFile);
                    reader.onload = () => {
                        this.newImageRender = reader.result;
                    };
                }
            },
            immediate: true,
        },
    },

    computed: {
        ...mapState('sgaPictograms', ['pictogram', 'action']),

        validationRuleImage() {
            return this.pictogram.imageBase64 ? 'mimes:image/jpeg,image/png,image/jpg' : 'required|mimes:image/jpeg,image/png,image/jpg';
        },

    },

    methods: {
        ...mapActions('sgaPictograms', ['createPictogramSga', 'getPictogramsSga', 'updatePictogramSga']),
        ...mapMutations('sgaPictograms', ['setDefaultPictogramSga']),

        cancelPictogram() {
            this.setDefaultPictogramSga();
            this.$bvModal.hide('modal_create_pictograms');
        },

        async cancelAndGetPictograms() {
            this.cancelPictogram();
            await this.getPictogramsSga();
        },

        async savePictogram() {
            const isValid = await this.$validator.validateAll('formPictograms');
            if (!isValid) return;

            let flag = false;
            if (this.action === 'edit') {
                flag = await this.updatePictogramSga(this.pictogram);
            } else {
                flag = await this.createPictogramSga(this.pictogram);
            }

            if (flag) {
                this.cancelAndGetPictograms();
            }
        },

        getImage(event) {
            this.pictogram.image = event.target.files[0];
        },
    }
}
</script>

<style scoped>

.img-pictogram {
    object-fit: contain; 
    border: 1px solid #e1e3e1;
    border-radius: 5px; 
    padding: 5px
}

</style>